(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wav-animations"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__wavAnimationsInit) return;
  window.__wavAnimationsInit = true;

  // Reveal au scroll, avec cascade automatique pour les groupes
  document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
    var children = group.querySelectorAll('[data-reveal]');
    children.forEach(function (child, i) {
      if (!child.style.transitionDelay) {
        child.style.transitionDelay = (i * 0.08) + 's';
      }
    });
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
})();
  } catch(e) { console.error(e); }
})();

})();
